import { createContext } from "react";

export interface PasteOptionsRequest {
  anchorRect: DOMRect;
  /** Present only when there is a plain-text alternative to switch to */
  onPlainText?: () => void;
  onCancel: () => void;
}

export interface PasteDialogContextProps {
  showPasteOptions: (req: PasteOptionsRequest) => void;
}

export const PasteDialogContext = createContext({} as PasteDialogContextProps);
